"use client";

// This page needs to be dynamically rendered to avoid prerendering issues
export const dynamic = "force-dynamic";

// Disable static generation for this page to avoid prerendering issues
export const fetchCache = "force-no-store";

import React, { useEffect, useMemo } from "react";
import { useTranslations, useLocale } from "next-intl";
import LegalLayout from "@/components/layout/LegalLayout";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function CompliancePage() {
  const t = useTranslations("compliance");
  const locale = useLocale();
  const lastUpdated = useMemo(() => {
    const date = new Date("2025-06-01T00:00:00Z");
    return new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "long",
    }).format(date);
  }, [locale]);

  usePageTitle(t("title"));

  return (
    <LegalLayout pageTitle={t("title")} lastUpdated={lastUpdated}>
      {/* 全球合规承诺 */}
      <div className="bg-indigo-50 dark:bg-indigo-900/20 rounded-lg p-6 border border-indigo-200 dark:border-indigo-800">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white tracking-tight mb-4">
          {t("globalCommitment")}
        </h2>
        <p className="mb-4 text-base text-gray-700 dark:text-gray-300 leading-relaxed">
          {t("intro")}
        </p>
        <ul className="list-disc pl-6 space-y-2 text-base text-gray-700 dark:text-gray-300">
          <li>{t("gdpr")}</li>
          <li>{t("uk_gdpr")}</li>
          <li>{t("ccpa")}</li>
          <li>{t("pipeda")}</li>
          <li>{t("appi")}</li>
          <li>{t("pipa")}</li>
          <li>{t("fz152")}</li>
          <li>{t("lgpd")}</li>
          <li>{t("lfpdppp")}</li>
          <li>{t("pipl")}</li>
          <li>{t("pdpa")}</li>
        </ul>
        <p className="mt-4 text-base text-gray-700 dark:text-gray-300 leading-relaxed">
          {t("dynamic")}
        </p>
      </div>

      {/* 用户权利 */}
      <div className="bg-emerald-50 dark:bg-emerald-900/20 rounded-lg p-6 border border-emerald-200 dark:border-emerald-800">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white tracking-tight mb-4">
          {t("rightsTitle")}
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-base text-gray-700 dark:text-gray-300">
          <li>{t("right1")}</li>
          <li>{t("right2")}</li>
        </ul>
      </div>

      {/* 本地化合规 */}
      <div className="bg-rose-50 dark:bg-rose-900/20 rounded-lg p-6 border border-rose-200 dark:border-rose-800">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white tracking-tight mb-4">
          {t("localizationTitle")}
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-base text-gray-700 dark:text-gray-300">
          <li>{t("localization1")}</li>
          <li>{t("localization2")}</li>
        </ul>
      </div>

      {/* 联系方式 */}
      <div className="bg-cyan-50 dark:bg-cyan-900/20 rounded-lg p-6 border border-cyan-200 dark:border-cyan-800">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white tracking-tight mb-4">
          {t("contactTitle")}
        </h2>
        <ul className="list-disc pl-6 space-y-2 text-base text-gray-700 dark:text-gray-300">
          <li>{t("contact1")}</li>
        </ul>
      </div>

      {/* 页脚信息 */}
      <div className="text-center mt-8 bg-gray-50 dark:bg-gray-800/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
        <div className="text-sm text-muted-foreground">{t("footer")}</div>
      </div>
    </LegalLayout>
  );
}
